import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'react-bootstrap/Card';
import styled from 'styled-components';



export const ColContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #F5F7FA;
  z-index: 100;
  opacity: 0.7;
`;

export const CardStyled = styled(Card)`
  background: #FFFFFF;
  border: none;
  border-radius: 8px !important;
  margin: 0 0 15px;
`;

export const CardHeaderStyled = styled(Card.Header)`
  background: transparent;
  border: none;
  border-radius: 8px !important;
  padding: 0.75rem 10px;
`;

export const RowStyled = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const TitleContainer = styled.div`
  margin: 0 20px;
`;

export const Title = styled.h4`
  color: #7A8799;
  font-size: 14px;
  margin: 0;
`;

export const Text = styled.p`
  margin: 0;
`;

export const ArrowDown = styled(FontAwesomeIcon)`
  position: absolute;
  right: 0;
`;

export const TextNotification = styled.p`
  font-family: 'Gotham';
  font-size: 14px;
  font-weight: 325;
  line-height: 18.2px;
  letter-spacing: -0.4px;
  color: #6C757D;
  margin-top: 55px;
  span {
    color: #343A40;
  }
  a {
    text-decoration: underline;
    font-weight: 500;
  }
`;
